import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'ecp-drop-down-menu',
    templateUrl: './drop-down-menu.component.html',
    styleUrls: ['./drop-down-menu.component.css'],
    animations: [
        trigger('displayState', [
            state('none', style({
                display: 'none', opacity: '0',
            })),
            state('block', style({
                display: 'block', opacity: '1',
            })),
            transition('none => block', animate('100ms linear')),
            transition('block => none', animate('80ms linear'))
        ])
    ]
})
export class DropDownMenuComponent implements OnInit {
    changeOpen: Boolean = false;
    @Input() ecpMenusList: Array<any>;
    @Input() ecpCurrentSys = 'åæ¢ç³»ç»';
    @Output() ecpNavHomeUrl = new EventEmitter(); // ä¸»é¡µè·³è½¬
    @Output() ecpNavUrl = new EventEmitter(); // äºçº§è·³è½¬


    navHome() {
        this.ecpNavHomeUrl.emit();
    }

    navSub(id) {
        this.ecpNavUrl.emit(id);
    }


    /*
      menusList: Array<any> = [{
        'menuid': 10000000,
        'parentid': 0,
        'name': 'è¥æ¶ç³»ç»',
        'uri': null,
        'iconuri': 'menu-1',
        'havechild': true,
        'child': null,
        'introduction': 'ä¸»è¦åæ¬è¥æ¶ä¸»é¡µç»è®¡ä¿¡æ¯ï¼ç¨æ·ä¿¡æ¯ç®¡çï¼è®¾å¤ç®¡çï¼æè¡¨ç®¡çï¼ç¼´è´¹ç®¡çç­åè½'
      }, {
        'menuid': 20000000,
        'parentid': 0,
        'name': 'ç®¡æ¼ç®¡ç',
        'uri': null,
        'iconuri': 'menu-2',
        'havechild': true,
        'child': null,
        'introduction': 'ä¸»è¦åæ¬ç®¡æ¼ç³»ç»åºæ¬ä¿¡æ¯ç»è®¡ï¼ç®¡æ¼ç¨æ·ç®¡çï¼ç®¡æ¼å®¢æ·ç®¡çï¼æµéè®¡ç®¡çç­åè½'
      }, {
        'menuid': 30000000,
        'parentid': 0,
        'name': 'æéç®¡ç',
        'uri': null,
        'iconuri': 'menu-3',
        'havechild': true,
        'child': null,
        'introduction': 'ä¸»è¦åè½åæ¬ç³»ç»å¸å·ç®¡çï¼è§è²æéç®¡çï¼å¸å·æéåéç­'
      }, {
        'menuid': 40000000,
        'parentid': 0,
        'name': 'ç³»ç»ç®¡ç',
        'uri': null,
        'iconuri': 'menu-4',
        'havechild': true,
        'child': null,
        'introduction': 'ä¸»è¦åè½åæ¬ç­ä¿¡æ¨¡æ¿ç®¡çï¼æ¥è¡¨æ¨¡æ¿ç®¡çï¼ç³»ç»ä¿¡æ¯éç½®ç­'
      }];

     */

    constructor() {
    }

    ngOnInit() {
    }

}
